<template>
    <div class="about">
        <b-row>
            <b-col>
                <h1>Help / About</h1>
                If you encounter any issues using Create Shipment, please consult this page, before
                contacting support.
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <h2>Caching</h2>
                <ul>
                    <li>
                        To improve performance, data used by Create Shipment is stored(cached) for
                        10 hours, before requesting new data from the server.
                    </li>
                    <li>
                        However if you choose to save address or description when creating a
                        shipment, those data are automatically reloaded, to ensure your addressbook
                        and saved descriptions are up to date.
                    </li>
                    <li>
                        For any other data please logout and login again, to clear the cache and
                        ensure you have the latest data.
                    </li>
                </ul>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col>
                <h2>File sizes</h2>
                The file size of uploaded documents cannot exceed 80 mb.
            </b-col>
        </b-row>

        <b-row class="mt-4">
            <b-col>
                <h2>Error Booking</h2>
                On the Create Shipment site, if the user has trouble getting a booking completed
                because of errors, it is possible to press CTRL + Q to create an Error Booking. This
                will create a booking with all the details entered by the user, but of the type
                ErrorBooking.
            </b-col>
        </b-row>

        <b-row class="mt-4">
            <b-col>
                <h2>Debugging</h2>
                On the Create Shipment site, you can press CTRL + 0 to print your shipment and
                shipment valdidations to the console. This can be helpful for debuggning of
                unexpected errors.
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ACTIONS, CORE_PREFIX } from '../store/constants';

export default {
    data() {
        return {};
    },
    mounted() {
        this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
    }
};
</script>
<style scoped>
.about {
    text-align: left !important;
}
</style>
